import { Component } from '@angular/core';

@Component( {
    templateUrl: './patent-search-form.component.html'
} )
export class PatentSearchFormComponent {
}
